import React from 'react'
import { Text } from 'react-native'

// It looks it is used on iOS only
const CircularProgress = () => (<Text>
  Not implemented for web
</Text>)

export default CircularProgress
